import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_usuarios/usuarios-editar";

export const Route = createFileRoute("/_authenticated/usuarios-editar")({
  component: PaginaRota,
});